import {Lesson, VisitedLesson, Activity} from './models/resources'
import {MAX_QUEUE} from './actions/flashcards'


export default {

  flashcards(state, flashcards) {
    state.flashcards = flashcards
  },

  // Merged rather than replaced: to_rehearse and review both report a fresh
  // due_now without knowing the streak, and stats knows everything.
  flashcardStats(state, stats) {
    state.flashcardStats = Object.assign({}, state.flashcardStats, stats)
  },

  queueFlashcardReview(state, entry) {
    state.flashcardQueue = state.flashcardQueue.concat([entry])
    if (state.flashcardQueue.length > MAX_QUEUE) {
      // Losing the oldest answers is better than losing the session; a dropped
      // entry only costs one card's scheduling accuracy.
      console.warn('Flashcard review queue overflowed, dropping oldest entries')
      state.flashcardQueue = state.flashcardQueue.slice(-MAX_QUEUE)
    }
  },

  dequeueFlashcardReview(state, entry) {
    state.flashcardQueue = state.flashcardQueue.filter(
      e => !(e.id === entry.id && e.answered_at === entry.answered_at)
    )
  },

  flashcardFlushing(state, flushing) {
    state.flashcardFlushing = flushing
  },

  editWord(state, {sentence, word}) {
    sentence.words[word.idx] = Object.assign({}, word)
    if (sentence.ipa) {
      sentence.ipa = sentence.ipa.replace(word.tts, word.content)
    }
    sentence.ipa_locked = true;
    Vue.set(
        state.lesson.sentences,
        sentence.index,
        Object.assign({}, sentence, {version: Date.now(), lastChange: sentence}))
    const sent = state.lesson.sentences.find(el => el.id == sentence.id)
    Vue.set(sent.words, word.idx, word)
  },

  SOMEONE_JOINED(state, data) {
    console.log("Mutation SOMEONE_JOINED", data)
  },

  messageThreads(state, threads) {
    state.messageThreads = threads
  },

  messageThread(state, thread) {
    state.messageThread = thread
  },

  appendMessage(state, message) {
    state.messageThread = Object.assign({}, state.messageThread, {
      messages: state.messageThread.messages.concat(message)
    })
  },

  threadRead(state, userId) {
    state.messageThreads = state.messageThreads.map(thread => (
      `${thread.user.id}` === `${userId}` ? Object.assign({}, thread, {unread_count: 0}) : thread
    ))
  },

  unreadMessagesCount(state, count) {
    state.unreadMessagesCount = count
  },

  messageSettings(state, settings) {
    state.messageSettings = settings
  },
}
